import controller from './admin-wf.controller';
import template from './admin-wf.html';
import '../schema.scss';
import './admin-wf.scss';

export default {
	controller,
	controllerAs:   '$ctrl',
	path:           '/admin/wf',
	reloadOnSearch: false,
	template,
	title:          'menu.admin-workflow',
};
